import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-select-columns-modal',
  templateUrl: './select-columns-modal.component.html',
  styleUrls: ['./select-columns-modal.component.css']
})
export class SelectColumnsModalComponent implements OnInit {
  @Input() initialColumns: string[];
  @Input() defaultColumns: string[];
  @Input() columnOptions: string[];
  @Input() columnHelpText: {[key: string]: string} = {};
  @Input() columnHeaderOverrides: {[key: string]: string} = {};
  @Input() savedCallback: (updatedColumns: string[]) => undefined;

  columns: string[] = [];

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.columns = [...this.initialColumns];
  }

  public shiftColumnByOne(columnIdx: number, shiftUp: boolean) {
    const column = this.columns[columnIdx];

    if (shiftUp && (columnIdx === 0)) { return; }
    if (!shiftUp && (columnIdx >= (this.columns.length - 1))) { return; }

    if (shiftUp) {
      this.columns[columnIdx] = this.columns[columnIdx - 1];
      this.columns[columnIdx - 1] = column;
    } else {
      this.columns[columnIdx] = this.columns[columnIdx + 1];
      this.columns[columnIdx + 1] = column;
    }
  }

  public shiftColumnToExtreme(columnIdx: number, shiftUp: boolean) {
    const column = this.columns[columnIdx];

    if (shiftUp && (columnIdx === 0)) { return; }
    if (!shiftUp && (columnIdx >= (this.columns.length - 1))) { return; }

    this.columns.splice(columnIdx, 1);
    if (shiftUp) {
      this.columns.unshift(column);
    } else {
      this.columns.push(column);
    }
  }

  public removeColumn(columnIdx: number) {
    this.columns.splice(columnIdx, 1);
  }

  public availableColumns() {
    return this.columnOptions.filter(item => !this.columns.includes(item));
  }

  public addColumn(columnName: string) {
    this.columns.push(columnName);
  }

  public handleSelectDefault() {
    this.columns = [...this.defaultColumns];
  }

  public handleSubmit() {
    this.savedCallback(this.columns);
    this.activeModal.close();
  }
}
